<template>
    <div>
        <div slot="Proveedores" class="pa-body">
            <div class="secondary-text ta-center mt10" v-if="!visibleProviders.length">No hay proveedores</div>

            <div class="section mb10 selectable" 
            v-for="provider in visibleProviders"
            :key="provider.rut"
            @click="OpenProviderStats(provider.rut)">
                <div class="flex fill align-center">
                    <avatar class="mr10"
                    :label="provider.name"
                    :color="pendingInvoices[provider.rut] ? Util.baseColors.red : Util.baseColors.blue">
                    </avatar>
                    <div class="flex-fill flex column">
                        <div class="bold">{{provider.name}}</div>
                        <div class="secondary-text" v-if="provider.company">{{provider.company}}</div>
                        <div class="secondary-text" v-if="provider.has_rut">{{Util.Rut(provider.rut)}}</div>
                    </div>

                    <div class="cred" v-if="pendingInvoices[provider.rut]">{{pendingInvoices[provider.rut]}} pendientes</div>
                    
                    <i class="options icon-dots-vertical ml10" v-if="canDeleteProvider || canEditProvider || canCreateInvoices" @click.stop="Options([
                        {text: 'Eliminar Proveedor', class: 'error-color', function: () => {DeleteProvider(provider.rut)}, confirm: `¿Eliminar proveedor?`, if: canDeleteProvider, icon: 'trash'},
                        {text: 'Editar Proveedor', function: () => {modalProvider = Util.Copy(provider, {edit: true})}, if: canEditProvider, icon: 'edit'},
                        {text: 'Registrar Factura/Boleta', class: 'selected-color', function: () => OpenModalInvoice(provider), if: canCreateInvoices, icon: 'square-plus'},
                    ])"></i>
                </div>
            </div>
        </div>
        <modal v-model="modalProviderStats" :title="'Detalles de Proveedor'" :dir="['right', 'right']" :modalClass="['fill borderless', 'md right h100']" hideActions>

        <input-date v-if="modalProviderStats && modalProviderStats.tab == 'Documentos'" slot="options" 
        icon="search" type="DATE" @OnAcceptDate="LoadProviderInvoices($event)"></input-date>
        <i class="options icon-dots-vertical ml5" slot="options" @click="Options([
            {text: 'Eliminar Proveedor', class: 'error-color', function: () => {DeleteProvider(modalProviderStats.provider.rut)}, confirm: `¿Eliminar proveedor?`, if: canDeleteProvider, icon: 'trash'},
            {text: 'Editar proveedor', function: () => {modalProvider = Util.Copy(modalProviderStats.provider, {edit: true})}, if: canEditProvider, icon: 'edit'},
            {text: 'Registrar Factura/Boleta', class: 'selected-color', function: () => {OpenModalInvoice(modalProviderStats.provider)}, if: canCreateInvoices, icon: 'square-plus'},
        ])"></i>

        <tabs :tabs="isAdmin ? ['General', 'Items', 'Documentos'] : ['General']" v-if="modalProviderStats" keyByTab
        v-model="modalProviderStats.tab"
        @OnTabFacturas="!modalProviderStats.history.length? LoadProviderInvoices() : null" @OnTabDocumentos="LoadProviderInvoices()">

            <div slot="General" class="pa20">
                
                <div class="mb15">
                    <div class="bold">Nombre</div>
                    <div>{{modalProviderStats.provider.name}}</div>
                </div>

                <div class="mb15" v-if="modalProviderStats.provider.has_rut">
                    <div class="bold">RUT</div>
                    <div>{{Util.Rut(modalProviderStats.provider.rut)}}</div>
                </div>

                <div class="mb15" v-if="modalProviderStats.provider.company">
                    <div class="bold">Razón Social</div>
                    <div>{{modalProviderStats.provider.company}}</div>
                </div>

                <div class="mb15" v-if="modalProviderStats.provider.email">
                    <div class="bold">Email</div>
                    <div>{{modalProviderStats.provider.email}}</div>
                </div>

                <div class="mb15" v-if="modalProviderStats.provider.phone">
                    <div class="bold">Teléfono</div>
                    <div>{{modalProviderStats.provider.phone}}</div>
                </div>

                <div class="mb15" v-if="modalProviderStats.provider.address">
                    <div class="bold">Dirección</div>
                    <div>{{modalProviderStats.provider.address}}</div>
                </div>

                <div class="separator mb20 mt20"></div>

                <div class="hs">
                    <div>
                        <div class="bold">Total</div>
                        <div>{{Util.Price(modalProviderStats.total)}}</div>
                    </div>
                    <div>
                        <div class="bold">Facturas</div>
                        <div>{{Util.Number(modalProviderStats.invoices)}}</div>
                    </div>
                    <div class="flex" style="justify-content: end">
                        <input-range v-model="modalProviderStats.range" icon="calendar" :triggerFirstValueChanged="false" @OnValueChanged="OpenProviderStats(null, $event)"></input-range>
                    </div>
                </div>
                
                <div v-if="modalProviderStats.pending.length && canPayInvoices">

                    <div class="separator mb20 mt20"></div>

                    <div class="f18 mb20">Facturas con Pago Pendiente</div>
                    <div class="entry selectable"
                    v-for="(invoice, index) in modalProviderStats.pending"
                    :key="index"
                    @click="$refs.invoiceDetails.Open(invoice)">
                        <div class="flex fill align-center">
                            <div class="flex column">
                                <div class="bold">Factura N°{{invoice.number}}</div>
                                <div class="secondary-text"><span class="bold">Ingresado por: </span>{{invoice.custom_data.created_by}}</div>
                                <div class="secondary-text"><span class="bold">Fecha: </span>{{Util.Date(invoice.created_at, 'DD/MM/YYYY')}}</div>
                            </div>
                            <div class="flex-fill"></div>
                            <div class="flex column mr10" style="text-align: right">
                                <div class="bold cred">{{Util.Price(invoice.total)}}</div>
                            </div>
                            <!--<i class="icon icon-arrow-right-o c4"></i>-->
                        </div>
                    </div>
                </div>

                <div v-if="modalProviderStats.pendingNotInvoice.length && canPayInvoices">

                    <div class="separator mb20 mt20"></div>

                    <div class="f18 mb20">Boletas con Pago Pendiente</div>
                    <div class="entry selectable"
                    v-for="(invoice, index) in modalProviderStats.pendingNotInvoice"
                    :key="index"
                    @click="$refs.invoiceDetails.Open(invoice)">
                        <div class="flex fill align-center">
                            <div class="flex column">
                                <div class="bold">Boleta N°{{invoice.number}}</div>
                                <div class="secondary-text"><span class="bold">Ingresado por: </span>{{invoice.custom_data.created_by}}</div>
                                <div class="secondary-text"><span class="bold">Fecha: </span>{{Util.Date(invoice.created_at, 'DD/MM/YYYY')}}</div>
                            </div>
                            <div class="flex-fill"></div>
                            <div class="flex column mr10" style="text-align: right">
                                <div class="bold cred">{{Util.Price(invoice.total)}}</div>
                            </div>
                            <!--<i class="icon icon-arrow-right-o c4"></i>-->
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="isAdmin" slot="Items" class="pa20">

                <div class="f18 mb20">Items</div>

                <div :class="`entry ${item.history.length > 1 ? 'selectable' : ''}`" v-for="item in modalProviderStats.items" :key="item.item"
                @click="$set(modalProviderStats, 'selectedItem', item.item)">
                    <div class="flex align-center">
                        <div class="flex-fill bold">{{ item.item }}</div>
                        <div class="ta-right">
                            <div class="bold">${{ Util.Number( view == 'INVENTORY' ? item.history[item.history.length-1].unit_cost :  item.history[item.history.length-1].money)}}</div>
                            <div class="secondary-text" v-if="view == 'INVENTORY' && inventory[item.item] && inventory[item.item].unit">pesos / {{inventory[item.item].unit}}</div>
                        </div>
                    </div>
                    <chart v-if="item.history.length > 1 && modalProviderStats.selectedItem == item.item" class="mt10 well"
                    type="line"
                    :data="[item.history]"
                    dataset="unit_cost"
                    :label="(data) => {return Util.Date(data.date)}"
                    height="200px"
                    :yLabelFormat="(value) => {return '$'+Util.Number(value)}"
                    :tooltip="(value, label, index) => {return `$${Util.Number(value)}`}"
                    :customColor="[Util.Chart.purpleGradient]">
                    </chart>
                </div>
            </div>

            <vertical-content slot="Documentos" ref="verticalInvoicesHistory"  class="pa20" v-if="modalProviderStats" @OnBottom="LoadProviderInvoices()">

                <div class="">
                    <div class="secondary-text ta-center mt10" v-if="!modalProviderStats.history.length">No hay documentos</div>
                    <div class="entry selectable"
                    v-for="(invoice, index) in modalProviderStats.history"
                    :key="index"
                    @click="$refs.invoiceDetails.Open(invoice)">
                        <div class="flex fill align-center">
                            <div class="flex column">
                                <div class="bold" v-if="!invoice.sii">{{invoice.is_invoice ? 'Factura' : 'Boleta'}} de {{ invoice.type == 'FACTURA_EXPENSES' ? 'Gastos' : 'Inventario' }} N°{{invoice.number}}</div>
                                <div class="bold" v-if="invoice.sii">Factura Electrónica N°{{invoice.number}}</div>
                                <div class="secondary-text" v-if="invoice.custom_data && invoice.custom_data.created_by"><span class="bold">Ingresado por: </span>{{invoice.custom_data.created_by}}</div>
                                <div class="secondary-text" v-if="invoice.issue_by"><span class="bold">Emitido por: </span>{{invoice.issue_by}}</div>
                                <div class="secondary-text" v-if="invoice.created_at"><span class="bold">Fecha: </span>{{Util.Date(invoice.created_at, 'DD/MM/YYYY')}}</div>
                                <div class="secondary-text" v-if="invoice.issue_at"><span class="bold">Fecha emisión: </span>{{Util.Date(invoice.issue_at, 'DD/MM/YYYY')}}</div>
                                <div class="secondary-text" v-if="invoice.status !== 'PENDING' && invoice.pay_method"><span class="bold">Método de Pago: </span><span>{{Util.PayMethod(invoice.pay_method)}}</span></div>
                            </div>
                            <div class="flex-fill"></div>
                            <div class="flex column mr10" style="text-align: right">
                                <div :class="`bold ${invoice.status == 'PENDING' ? 'cred' : ''}`">{{Util.Price(invoice.total)}}</div>
                                <div class="secondary-text" v-if="invoice.status == 'PENDING'">Pago Pendiente</div>
                            </div>
                            <!--<i class="icon icon-arrow-right-o c4"></i>-->
                        </div>
                    </div>
                </div>

            </vertical-content>
        </tabs>
        </modal>
        <invoice-modal 
        ref="invoice" 
        :view="view" 
        :inventory="inventory" 
        @LoadProviders="LoadProviders()"
        @LoadProviderInvoices="LoadProviderInvoices()"
        @UpdateInventory="view == 'INVENTORY' ? $emit('UpdateInventory') : null"
        @LoadInExpense="LoadInExpense"
        @PrintInvoice="$refs.invoiceDetails.PrintInvoiceVoucher($event)"
        @ProviderStats="ProviderStats()"
        ></invoice-modal>

        <invoice-details 
        @OnInvoicePaid="OpenProviderStats(); LoadProviders()" 
        @OnInvoiceDeleted="OpenProviderStats(); LoadProviders(); DeleteInvoice();" 
        @OnEditInvoice="$refs.invoice.ModalEditInvoice($event)"
        @ProviderStats="OpenProviderStats()"
        @LoadProviders="LoadProviders()"
        @LoadProviderInvoices="LoadProviderInvoices(null, true)"
        ref="invoiceDetails">
        </invoice-details>

        <modal v-model="modalProvider" dir="right" :modalClass="['fill', 'sm right h100']" :title="modalProvider && modalProvider.edit ? 'Editar Proveedor' : 'Nuevo Proveedor'">

            <div class="section" v-if="modalProvider">
                <input-field class="mb15"
                v-model="modalProvider.name"
                label="Nombre">
                </input-field>

                <label class="mb15">
                    <input type="checkbox" v-model="modalProvider.has_rut"> Registrar con RUT <div class="checkmark"></div>
                </label>

                <input-field v-if="modalProvider.has_rut" :readonly="modalProvider.edit" class="mb15"
                v-model="modalProvider.rut"
                label="RUT">
                </input-field>

                <input-field class="mb15"
                v-model="modalProvider.email"
                label="Email"
                placeholder="(Opcional)">
                </input-field>
                
                <input-field class="mb15"
                v-model="modalProvider.phone"
                label="Teléfono"
                placeholder="(Opcional)">
                </input-field>

                <input-field class="mb15"
                v-model="modalProvider.company"
                label="Razon Social"
                placeholder="(Opcional)">
                </input-field>

                <input-field
                v-model="modalProvider.address"
                label="Dirección"
                placeholder="(Opcional)">
                </input-field>

            </div> 
            
            <button slot="actions" class="primary purple" @click="SaveProvider()">Guardar</button>
            
        </modal>
    </div>
</template>
<script>
export default {
    props: {
        view: {
            type: String,
            default: 'INVENTORY'
        },
        payMethods : {
            type : Array,
            default : [] 
        },
        inventory : {
            type : Object,
            default : null
        },
        expenses : {
            type : Array,
            default : null
        },
        search : {
            type : String,
            default : ''
        },

    },
    data() {
        return {
            providers : [],
            pendingInvoices : {},
            modalProvider : null,
            modalProviderStats : null,
            modalInvoice: null,
            modalProviderItem : null,
            modalLastInvoices : null
        }
    },
    methods : {

        LoadProviders(){
            this.$emit('LoadProviders');
            // axios.get(`/providers/${this.Local.id}/v2${'?view='+this.view}`).then(res => {
            //     this.Response(res);
            //     this.providers = res.data.providers;
            //     this.pendingInvoices = res.data.counts;
            //     this.$emit('SetProviders',this.providers);
            // }).catch(err => {
            //     this.Response(err);
            // });
        },
        OpenProviderStats(provider, range)
        {

            if(!provider && this.modalProviderStats) provider = this.modalProviderStats.provider.rut;
            if(!provider) return;

            if (range && (!range.rangeStart || !range.rangeEnd)) return;
            this.Loading();
            axios.get(`/providers/${this.Local.id}/stats/${provider}${range ? '?start='+range.rangeStart+'&finish='+range.rangeEnd : ''}${'?view='+this.view}`).then(res => {
                this.Response(res);
                if(range)
                {
                    this.$set(this.modalProviderStats, 'total', res.data.total);
                    this.$set(this.modalProviderStats, 'invoices', res.data.invoices);
                }
                else
                {
                    res.data.history = [];
                    res.data.range = 'NONE';
                    this.modalProviderStats = res.data;
                }
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadProviderInvoices(range, empty) {
            if(!this.modalProviderStats) return;
            if(empty) this.$set(this.modalProviderStats, 'history', []);
            var invoices = this.modalProviderStats.history;
            var date = invoices.length ? invoices[invoices.length-1].created_at-1 : null;
            if(range)
            {
                this.$refs.verticalInvoicesHistory.Reset();
                date = range.endOf('day').unix();
                this.modalProviderStats.history = [];
            }

            this.Loading();
            axios.get(`/provider/${this.Local.id}/invoices/${this.modalProviderStats.provider.rut}${date?'/'+date:''}?view=${this.view}`).then(res => {
                this.Response(res);
                this.modalProviderStats.history = this.modalProviderStats.history.concat(res.data);
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteInvoice(){
            this.$set(this.modalProviderStats, 'history', []);
            if(this.view == 'EXPENSES') this.LoadInExpense();
            this.LoadProviderInvoices();
        },
        SaveProvider()
        {
            if(!this.modalProvider.name || (this.modalProvider.has_rut ? !this.modalProvider.rut : false)) return this.Info('Datos inválidos');

            if(this.modalProvider.edit)
            {
                this.Loading();
                axios.patch(`/providers/${this.Local.id}/${this.modalProvider.rut}`, this.modalProvider).then(res => {
                    this.Response(res);
                    this.providers = res.data;
                    this.modalProvider = null;
                    this.modalProviderStats = null;
                }).catch(err => {
                    this.Response(err);
                });
            }
            else
            {
                if(!this.modalProvider.has_rut) this.modalProvider.rut = Util.GenerateRandomRut();
                this.Loading();
                axios.put(`/providers/${this.Local.id}`, this.modalProvider).then(res => {
                    this.Response(res);
                    this.$emit('SetProviders', res.data);
                    this.providers = res.data;
                    this.modalProvider = null;
                }).catch(err => {
                    this.Response(err);
                });
            }
        },
        DeleteProvider(provider) 
        {
            this.Loading();
            axios.delete(`/providers/${this.Local.id}/${provider}`).then(res => {
                this.Response(res);
                this.providers = res.data;
                this.modalProviderStats = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        ExportProviders() 
        {
            this.Loading();
            axios.get(`/inventory/${this.Local.id}/providers/export`, {responseType: 'blob'}).then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `proveedores_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });
        },

        OpenModalInvoice(provider){
            let expense = true;
            if (this.$refs.invoice.canExpenseTurn) {
                expense = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expense == null) expense = true;
            }
            this.$refs.invoice.modalInvoice = {inventory: [], provider: provider, view: this.view, is_invoice : 1, expense_turn : expense};
            this.$refs.invoice.payMethods = this.payMethods;
            if(this.view == 'INVENTORY') this.$refs.invoice.inventory = this.inventory;
            else if(this.view == 'EXPENSES') this.$refs.invoice.expenses = this.expenses;
        },
        LoadInExpense() {
            this.$emit('LoadExpenses');
            this.$emit('LoadHistory');
            this.$emit('Search');
        },
        ProviderStats() {
            if(this.modalProviderStats) this.OpenProviderStats();
            if(this.modalProviderStats) this.$set(this.modalProviderStats, 'history', []);
            
        }
    },
    computed : {
        visibleProviders() {
            if(!this.providers) return [];
            var ret = [];
            for(var key in this.providers)
            {
                if(this.Util.InString(`${this.providers[key].name} ${key}`, this.search))
                    ret.push(this.providers[key]);
            }
            return this.Util.NaturalSort(ret, 'name');
        },
        canPayInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.pay_pending_inventory_invoices);
        },
        canCreateProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_providers);
        },
        canDeleteProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1);
        },
        canEditProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_providers);
        },
        canCreateInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_inventory_invoices);
        },
    }
}
</script>